import { useEffect } from "react";
import L from "leaflet";
import { useMap } from "react-leaflet";
import { OpenStreetMapProvider, GeoSearchControl } from "leaflet-geosearch";
import { type MapLocation } from "../utils/types";

type SearchControlProps = {
  onLocationFound?: (mapLocation: MapLocation) => void;
};

const SearchControl = ({ onLocationFound }: SearchControlProps) => {
  const map = useMap();
  useEffect(() => {
    if (!map) return;

    const provider = new OpenStreetMapProvider();
    const searchControl = new GeoSearchControl({
      provider,
      style: "bar",
      showMarker: false,
      showPopup: false,
      retainZoomLevel: false,
      autoClose: true,
      searchLabel: "Enter pickup address...",
      keepResult: true,
    });
    const leafletControl = searchControl as unknown as L.Control;
    map.addControl(leafletControl);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleShowLocation = (result: any) => {
      const { x: lng, y: lat, label } = result.location;
      if (onLocationFound) {
        onLocationFound({
          address: label,
          latitude: lat,
          longitude: lng,
        });
      }
    };
    map.on("geosearch/showlocation", handleShowLocation);

    return () => {
      map.off("geosearch/showlocation", handleShowLocation);
      map.removeControl(leafletControl);
    };
  }, [map, onLocationFound]);

  return null;
};

export default SearchControl;
